import IconItem from './icon_item';

export default class Print extends IconItem {
  constructor() {
    super('print', 'Ctrl+P');
  }
}
